import { render } from "./tpl_goods.vue?vue&type=template&id=3dfaf156&scoped=true"
import script from "./tpl_goods.vue?vue&type=script&lang=js"
export * from "./tpl_goods.vue?vue&type=script&lang=js"

import "./tpl_goods.vue?vue&type=style&index=0&id=3dfaf156&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfaf156"],['__file',"src/views/wap/template/tpl_goods.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dfaf156"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dfaf156', __exports__)) {
    console.log('reload')
    api.reload('3dfaf156', __exports__)
  }
  
  module.hot.accept("./tpl_goods.vue?vue&type=template&id=3dfaf156&scoped=true", () => {
    console.log('re-render')
    api.rerender('3dfaf156', render)
  })

}


export default __exports__